import src from "IMAGE";
export default { src, width: 116, height: 25, blurWidth: 0, blurHeight: 0};
